__turbopack_context__.v({
  "buttonGroup": "DraggableQuestionnaireItems-module__s1ta0q__buttonGroup",
  "textEditor": "DraggableQuestionnaireItems-module__s1ta0q__textEditor",
});
